<script setup lang="ts">
import { computed } from "vue";

const props = defineProps({
  selected: { type: Number, default: undefined },
  min: { type: Number, required: true },
  max: { type: Number, required: true },
  low: { type: String, required: true },
  high: { type: String, required: true },
  labelledby: { type: String, required: true },
});
const emit = defineEmits({ select: (_value: number) => true });

const values = computed(() =>
  Array.from({ length: props.max - props.min + 1 }, (_, i) => props.min + i),
);

function label(value: number): string {
  if (value === props.min) return `${value}, ${props.low}`;
  if (value === props.max) return `${value}, ${props.high}`;
  return String(value);
}
</script>

<template>
  <div>
    <div role="group" :aria-labelledby="labelledby" class="flex gap-1">
      <button
        v-for="value in values"
        :key="value"
        type="button"
        :aria-label="label(value)"
        :aria-pressed="selected === value"
        class="min-w-0 flex-1 rounded-md py-1.5 text-sm font-medium text-gray-800 tabular-nums ring-1 ring-gray-200 transition-colors ring-inset hover:bg-purple-50 hover:ring-purple-300 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-violet-700 aria-pressed:bg-purple-50 aria-pressed:text-purple-800 aria-pressed:ring-purple-700"
        @click="emit('select', value)"
      >
        {{ value }}
      </button>
    </div>
    <div
      aria-hidden="true"
      class="mt-1 flex justify-between text-xs text-gray-500"
    >
      <span>{{ low }}</span>
      <span>{{ high }}</span>
    </div>
  </div>
</template>
